export default "__VITE_ASSET__DJJDab8o__"